import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { MenuItem } from '../../context-menus/components/menu-item';
import { useFullscreenModalControls } from '../../modals/context/modal-context-provider';

export function ManageEventMergeMenuItem({
    contextMenuItemView,
    clickParams,
}: {
    clickParams: EventContextMenuClickParams;
    contextMenuItemView: ContextMenuItemView;
}): React.ReactElement {
    const modalControls = useFullscreenModalControls();
    const handleSelect = (): void => {
        modalControls.open({
            type: 'MANAGE_EVENT_MERGE',
            props: {
                primaryEventParameters: {
                    id: clickParams.eventId,
                },
            },
        });
    };

    return <MenuItem contextMenuItemView={contextMenuItemView} onSelect={handleSelect} />;
}
